function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "fill_forms");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M472.64653,398.128s83,4,88,33-97,3-97,3Z",
  transform: "translate(-93.85347 -131.6937)",
  fill: "#a0616a"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M341.64653,306.128s14,4,25,28,33,46,33,46l89,17-15,45-85-11-53-30Z",
  transform: "translate(-93.85347 -131.6937)",
  fill: "#575a89"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M341.64653,306.128s14,4,25,28,33,46,33,46l89,17-15,45-85-11-53-30Z",
  transform: "translate(-93.85347 -131.6937)",
  opacity: 0.1
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 824.29306,
  y: 92.93432,
  width: 105,
  height: 2,
  fill: "#3f3d56"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 409.29306,
  y: 92.93432,
  width: 333,
  height: 2,
  fill: "#3f3d56"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 30.29306,
  y: 333.93432,
  width: 789,
  height: 301,
  fill: "#3f3d56"
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  points: "115.793 128.434 124.793 185.434 186.793 188.434 179.793 104.434 115.793 128.434",
  fill: "#a0616a"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M144.14653,640.628l-3,126h94l14-50,11,50h98s2-144-9-145S144.14653,640.628,144.14653,640.628Z",
  transform: "translate(-93.85347 -131.6937)",
  fill: "#2f2e41"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 135.79306,
  cy: 89.43432,
  r: 54,
  fill: "#a0616a"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M138.64653,646.128l28-138-37-183,85.21434-31.97582,41.78566-5.02418,21.00654-3.92147,14.99346,3.92147s60,15,63,26-12,101-12,101l-14,74,31,133s-129,44-220,24Z",
  transform: "translate(-93.85347 -131.6937)",
  fill: "#575a89"
});

var _ref13 = /*#__PURE__*/React.createElement("polygon", {
  points: "82.293 243.934 82.293 280.934 200.285 281.095 88.293 268.934 82.293 243.934",
  opacity: 0.1
});

var _ref14 = /*#__PURE__*/React.createElement("polygon", {
  points: "72.159 346.12 220.293 324.934 72.159 366.89 72.159 346.12",
  opacity: 0.1
});

var _ref15 = /*#__PURE__*/React.createElement("polygon", {
  points: "307.293 248.934 291.412 306.159 318.293 250.822 307.293 248.934",
  opacity: 0.1
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M274.08747,166.97162l9.93007-3.97545s-20.76282-22.85871-49.65048-20.8709l8.12483-8.94481s-19.86015-7.95077-37.9148,12.92013c-9.491,10.97136-20.47216,23.86767-27.31776,38.39517H166.62491l4.4384,9.77288-15.53444,9.77288,15.94458-1.75541a54.612,54.612,0,0,0-.43268,16.21013,20.97371,20.97371,0,0,0,7.68035,13.72061h0s12.3151-25.49107,12.3151-29.46652v9.93858s9.93007-8.94467,9.93007-14.90777l5.41635,6.957,2.70817-10.93248,33.40108,10.93248-5.41635-8.94468,20.76283,2.98155-8.12483-10.93248s23.471,12.92013,24.37393,23.85261c.90262,10.93232,7.77269,21.29141,7.77269,21.29141S300.26671,181.8794,274.08747,166.97162Z",
  transform: "translate(-93.85347 -131.6937)",
  fill: "#2f2e41"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 233.29306,
  y: 234.93432,
  width: 384,
  height: 401,
  fill: "#d0cde1"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 273.29306,
  y: 322.93432,
  width: 284,
  height: 40,
  fill: "#004970"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 322.11632,
  y: 428.93432,
  width: 185.99441,
  height: 20,
  fill: "#004970"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 322.47538,
  y: 463.93432,
  width: 185.99441,
  height: 20,
  fill: "#004970"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 322.83445,
  y: 498.93432,
  width: 92.9972,
  height: 20,
  fill: "#004970"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 519.29306,
  y: 599.93432,
  width: 43,
  height: 20,
  fill: "#004970"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M299.64653,417.128s87-13,100,6-92,29-92,29Z",
  transform: "translate(-93.85347 -131.6937)",
  fill: "#a0616a"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M139.64653,324.128h-6.26587a10.21521,10.21521,0,0,0-6.9558,2.707c-5.94794,5.52277-18.52459,19.7749-23.77833,45.293-7,34-19,100,8,105s204-19,204-19l-13-46-128,1s2-22-2-36S139.64653,324.128,139.64653,324.128Z",
  transform: "translate(-93.85347 -131.6937)",
  fill: "#575a89"
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  cx: 409.29306,
  cy: 93.93432,
  r: 41,
  fill: "#d0cde1"
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  cx: 596.29306,
  cy: 93.93432,
  r: 41,
  fill: "#3f3d56"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M877.14653,267.628a42,42,0,1,1,42-42A42.0475,42.0475,0,0,1,877.14653,267.628Zm0-82a40,40,0,1,0,40,40A40.04551,40.04551,0,0,0,877.14653,185.628Z",
  transform: "translate(-93.85347 -131.6937)",
  fill: "#3f3d56"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M1064.14653,267.628a42,42,0,1,1,42-42A42.0475,42.0475,0,0,1,1064.14653,267.628Zm0-82a40,40,0,1,0,40,40A40.04551,40.04551,0,0,0,1064.14653,185.628Z",
  transform: "translate(-93.85347 -131.6937)",
  fill: "#3f3d56"
});

var _ref29 = /*#__PURE__*/React.createElement("polygon", {
  points: "403.641 111.377 385.873 87.688 392.273 82.887 404.506 99.197 460.745 42.959 466.401 48.615 403.641 111.377",
  fill: "#3f3d56"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 16.49572,
  y: 633.8306,
  width: 816.59467,
  height: 2.78201,
  fill: "#3f3d56"
});

var SvgFail = function SvgFail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e4efdc2f-150c-4196-a68d-a8467dcc9971",
    "data-name": "Layer 1",
    width: 1012.29306,
    height: 636.61261,
    viewBox: "0 0 1012.29306 636.61261",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fail.8c4799f4.svg";
export { ForwardRef as ReactComponent };